/* eslint-disable */
import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Badge,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  Select,
  HStack,
  IconButton,
} from '@chakra-ui/react';
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { SearchIcon } from '@chakra-ui/icons';
import { MdVisibility } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import Card from 'components/card/Card';
import React from 'react';
import { formatDate } from 'utils/format';

const columnHelper = createColumnHelper();

export default function StudentsTable(props) {
  const {
    tableData = [],
    pagination,
    searchQuery = '',
    onSearchChange,
    onPageChange,
    onItemsPerPageChange,
  } = props;
  const navigate = useNavigate();
  const [sorting, setSorting] = React.useState([]);
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('secondaryGray.200', 'whiteAlpha.100');
  const bgStatus = useColorModeValue('secondaryGray.100', 'whiteAlpha.100');
  const inputBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const inputText = useColorModeValue('secondaryGray.700', 'white');
  const searchIconColor = useColorModeValue('secondaryGray.700', 'white');
  const buttonBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');
  const buttonHover = useColorModeValue(
    { bg: 'secondaryGray.400' },
    { bg: 'whiteAlpha.50' }
  );
  const iconColor = useColorModeValue('brand.500', 'white');

  const columns = [
    columnHelper.accessor('matricule', {
      id: 'matricule',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="secondaryGray.600"
        >
          MATRICULE
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700" fontFamily="mono">
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor('name', {
      id: 'name',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="secondaryGray.600"
        >
          NAME
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="600">
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor('email', {
      id: 'email',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="secondaryGray.600"
        >
          EMAIL
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm">
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor('center', {
      id: 'center',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="secondaryGray.600"
        >
          CENTER
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="500">
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor('region', {
      id: 'region',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="secondaryGray.600"
        >
          REGION
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="500">
          {info.getValue() ?? '—'}
        </Text>
      ),
    }),
    columnHelper.accessor('field', {
      id: 'field',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="secondaryGray.600"
        >
          FIELD
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="500">
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor('contact', {
      id: 'contact',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="secondaryGray.600"
        >
          CONTACT
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontFamily="mono">
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor('application_date', {
      id: 'application_date',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="secondaryGray.600"
        >
          APPLICATION DATE
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="500">
          {formatDate(info.getValue())}
        </Text>
      ),
    }),
    columnHelper.display({
      id: 'actions',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="secondaryGray.600"
        >
          ACTIONS
        </Text>
      ),
      cell: (info) => (
        <IconButton
          aria-label="View student"
          icon={<MdVisibility />}
          size="sm"
          variant="ghost"
          colorScheme="blue"
          onClick={() => navigate(`/admin/student/${info.row.original.id}`)}
        />
      ),
    }),
  ];

  const table = useReactTable({
    data: tableData,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: false,
  });

  return (
    <Card flexDirection="column" w="100%" px="0px" overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex px="25px" mb="8px" justifyContent="space-between" align="center" flexWrap="wrap" gap="15px">
        <Text color={textColor} fontSize="22px" fontWeight="700" lineHeight="100%">
          All Students
        </Text>
        <InputGroup w={{ base: "100%", md: "300px" }}>
          <InputLeftElement pointerEvents="none">
            <SearchIcon color={searchIconColor} w="15px" h="15px" />
          </InputLeftElement>
          <Input
            variant="search"
            fontSize="sm"
            bg={inputBg}
            color={inputText}
            fontWeight="500"
            _placeholder={{ color: "secondaryGray.600", fontSize: "14px" }}
            borderRadius="30px"
            placeholder="Search students..."
            value={searchQuery}
            onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
          />
        </InputGroup>
      </Flex>
      <Box>
        <Table variant="simple" color="secondaryGray.700" mb="24px" mt="12px">
          <Thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <Tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <Th
                    key={header.id} borderColor={borderColor} pe="10px"
                    cursor="pointer"
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="secondaryGray.600"
                    >
                      {flexRender(header.column.columnDef.header, header.getContext())}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody>
            {table.getRowModel().rows.length === 0 ? (
              <Tr>
                <Td colSpan={columns.length} textAlign="center" py="20px">
                  <Text color={textColor} fontSize="sm">
                    No students found
                  </Text>
                </Td>
              </Tr>
            ) : (
              table.getRowModel().rows.map((row) => (
                <Tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <Td
                      key={cell.id}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                    >
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </Td>
                  ))}
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      {/* Pagination Controls */}
      {pagination && (
        <Flex
          px="25px"
          py="20px"
          justifyContent="space-between"
          align="center"
          flexWrap="wrap"
          gap="15px"
          borderTop="1px solid"
          borderColor={borderColor}
        >
          <HStack spacing="10px">
            <Text color={textColor} fontSize="sm" fontWeight="500">
              Items per page:
            </Text>
            <Select
              value={pagination.itemsPerPage}
              onChange={(e) => onItemsPerPageChange && onItemsPerPageChange(Number(e.target.value))}
              w="80px"
              size="sm"
              bg={inputBg}
              color={inputText}
              borderColor={borderColor}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Select>
          </HStack>

          <HStack spacing="10px">
            <Text color={textColor} fontSize="sm" fontWeight="500">
              {pagination.total > 0 ? (
                <>
                  Showing {((pagination.currentPage - 1) * pagination.itemsPerPage) + 1} to{' '}
                  {Math.min(pagination.currentPage * pagination.itemsPerPage, pagination.total)} of{' '}
                  {pagination.total} entries
                </>
              ) : (
                'No entries'
              )}
            </Text>
          </HStack>

          <HStack spacing="5px">
            <Button
              size="sm"
              bg={buttonBg}
              _hover={buttonHover}
              _active={buttonHover}
              onClick={() => onPageChange && onPageChange(pagination.currentPage - 1)}
              isDisabled={pagination.currentPage === 1}
              color={textColor}
            >
              Previous
            </Button>
            <Button
              size="sm"
              bg={buttonBg}
              _hover={buttonHover}
              _active={buttonHover}
              onClick={() => onPageChange && onPageChange(pagination.currentPage + 1)}
              isDisabled={
                pagination.currentPage >= Math.ceil(pagination.total / pagination.itemsPerPage) ||
                pagination.total === 0
              }
              color={textColor}
            >
              Next
            </Button>
          </HStack>
        </Flex>
      )}
    </Card>
  );
}
